import {DateTime, TimeSpan} from 'util/time';

interface CacheItem {
  value: any;
  expiration: DateTime|null;
}

let _cache: {[index:string]: CacheItem} = {};

// TODO: max cached items?

export function setCacheItem(key: string, value: any, expiration: DateTime|TimeSpan|null = null) {
  let expirationTime = null;
  if(expiration instanceof DateTime) {
    expirationTime = expiration;
  } else if(expiration instanceof TimeSpan) {
    expirationTime = (DateTime.now()).add(expiration);
  }
  _cache[key] = { value: value, expiration: expirationTime };
}

export function getCacheItem(key: string): any {
  const item = _cache[key];
  if(!item) {
    return undefined;
  }
  if(item.expiration && item.expiration.lessThan(DateTime.now())) {
    delete _cache[key];
    return undefined;
  }
  return item.value;
}

export function removeCacheItem(key: string) {
  if(_cache) {
    delete _cache[key];
  }
}